import React, { FC } from 'react';
import { NavbarItem } from './NavbarItem';
import {
  DashboardIcon,
  TenancyIcon,
  DocumentsIcon,
  PaymentsIcon,
  AccountIcon,
  SettingsIcon,
  SupportIcon,
  ChatsIcon,
  TicketsIcon,
} from './Icons';

interface TenantMenuProps {
  isCollapsed?: boolean;
}

export const TenantMenu: FC<TenantMenuProps> = ({ isCollapsed = false }) => {
  return (
    <>
      <NavbarItem to={'/'} icon={<DashboardIcon />} exact={true} isCollapsed={isCollapsed}>
        Dashboard
      </NavbarItem>

      <NavbarItem to={'/tenancy'} icon={<TenancyIcon />} isCollapsed={isCollapsed}>
        Tenancy
      </NavbarItem>

      <NavbarItem to={'/documents'} icon={<DocumentsIcon />} isCollapsed={isCollapsed}>
        Documents
      </NavbarItem>

      <NavbarItem to={'/payments'} icon={<PaymentsIcon />} isCollapsed={isCollapsed}>
        Payments
      </NavbarItem>

      <NavbarItem to={'/tickets'} icon={<TicketsIcon />} isCollapsed={isCollapsed}>
        Tickets
      </NavbarItem>

      <NavbarItem to={'/notifications'} icon={<ChatsIcon />} isCollapsed={isCollapsed}>
        Notifications
      </NavbarItem>

      <NavbarItem to={'/chats'} icon={<ChatsIcon />} isCollapsed={isCollapsed}>
        Chats
      </NavbarItem>

      <NavbarItem to={'/account'} icon={<AccountIcon />} isCollapsed={isCollapsed}>
        Account
      </NavbarItem>

      <NavbarItem to={'/settings'} icon={<SettingsIcon />} disabled={true} isCollapsed={isCollapsed}>
        Settings
      </NavbarItem>

      <NavbarItem to={'/support'} icon={<SupportIcon />} disabled={true} isCollapsed={isCollapsed}>
        Support
      </NavbarItem>
    </>
  );
};
